import React from 'react'
import { useTranslation } from 'react-i18next'
import {Button, ButtonProps} from 'antd'
import {Icon} from '@/components'
import {EXPORT_BUTTON} from '@/constants/playwright-ids'

export const ExportButton: React.FC<ButtonProps> = ({ children, ...rest }) => {
    const { t } = useTranslation()
    return (
    <Button
        data-test-id={EXPORT_BUTTON}
        icon={
            <Icon
                onClick={(e) =>
                    e.preventDefault()
                }
                type={
                    'download_document'
                }
            />
        }
        type={'link'}
        {...rest}
    >
        {children || t('ExportButton.export')}
    </Button>
)}
